import CheckoutContactInfoSimpleForm from './CheckoutContactInfoSimpleForm'
export default CheckoutContactInfoSimpleForm
